import { render, staticRenderFns } from "./OverlayAddressEdit.vue?vue&type=template&id=85060852&"
import script from "./OverlayAddressEdit.vue?vue&type=script&lang=js&"
export * from "./OverlayAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85060852')) {
      api.createRecord('85060852', component.options)
    } else {
      api.reload('85060852', component.options)
    }
    module.hot.accept("./OverlayAddressEdit.vue?vue&type=template&id=85060852&", function () {
      api.rerender('85060852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayAddressEdit.vue"
export default component.exports